var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYtLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.81543 8.86032C0.81543 4.31021 4.53824 0.587402 9.08835 0.587402C13.6385 0.587402 17.3613 4.31021 17.3613 8.86032C17.3613 13.4104 13.6385 17.1332 9.08835 17.1332C4.53824 17.1332 0.81543 13.4104 0.81543 8.86032ZM13.3799 6.74038C13.2765 6.37844 12.9663 6.06821 12.6043 5.9648C11.9322 5.75798 9.24346 5.75798 9.24346 5.75798C9.24346 5.75798 6.55477 5.75798 5.88259 5.9648C5.52065 6.06821 5.21042 6.37844 5.10701 6.74038C4.95189 7.41256 4.95189 8.86032 4.95189 8.86032C4.95189 8.86032 4.95189 10.3081 5.15871 10.9803C5.26212 11.3422 5.57236 11.6524 5.9343 11.7558C6.60647 11.9627 9.29517 11.9627 9.29517 11.9627C9.29517 11.9627 11.9839 11.9627 12.656 11.7558C13.018 11.6524 13.3282 11.3422 13.4316 10.9803C13.6385 10.3081 13.6385 8.86032 13.6385 8.86032C13.6385 8.86032 13.5867 7.41256 13.3799 6.74038ZM8.46788 10.3081V7.61938L10.6395 8.96373L8.46788 10.3081Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtLink);
export default __webpack_public_path__ + "static/media/yt_link.f35de8a3365601682b63d36dd9c15862.svg";
export { ForwardRef as ReactComponent };